import React from 'react';
import { Logo } from '../components/Logo';
import { Loader2Icon } from 'lucide-react';
export function LoadingScreen() {
  return <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-navy" data-id="element-672" data-mp="1fb6gqzgaboq3">
      <Logo size="lg" className="mb-8" data-id="element-673" data-mp="11ji5eydv14a6" />

      <div className="flex flex-col items-center" data-id="element-674" data-mp="11igseodaa7pt">
        <Loader2Icon className="w-8 h-8 text-amber animate-spin mb-6" data-id="element-675" data-mp="16ico80btusua" />
        <h2 className="text-xl font-serif text-white mb-2" data-id="element-676" data-mp="rllwmd8ealf8">
          Loading documents...
        </h2>
        <p className="text-gray-400 text-sm" data-id="element-677" data-mp="wlq3rcney3ss">
          This may take a few seconds for large cases.
        </p>
      </div>
    </div>;
}